import React, { useContext } from 'react';
import moment from 'moment';
import { FlowContext } from '../../core/flow-engine';
import config from '../../config';
import { MFBeaconButton, MFBeaconModal } from '../Beacon/BeaconComponents';
import { pushToBrokerageDelegateUser } from '../../flows/internal-account-finder/utils';
import { navigateToExternal } from '../../core/util';
import styles from './styles.css';

const ApplicationInProgressModal = () => {
  const { appState } = useContext(FlowContext);
  const { chosen, store } = appState;
  const { loadedData = {} } = store || {};
  const inprogressApplication = loadedData?.inprogressApplication;
  const modalTitle = 'Application already in progress.';
  const modalDescription2 =
    'Edit In-Progress Application to return to the last completed application step. Continue Anyway to override the application in progress and open a new one. The application will be permanently deleted.';

  const handleEditInProgressApplication = async () => {
    navigateToExternal(
      `${config(
        'internalReturnUrlPrefix'
      )}personal-investing/new-account/setup/brokerage/${chosen}/${inprogressApplication?.progressStepText ||
        'complete-profile'}?applicationID=${
        inprogressApplication?.applicationID
      }&delegateUser=${loadedData.customerId}`
    );
  };

  return (
    <>
      <MFBeaconModal id="appInProgressModal">
        <div className="beacon-modal__title">{modalTitle}</div>
        <div className="beacon-modal__description">
          There was a <strong>{inprogressApplication?.displayName}</strong>{' '}
          started on{' '}
          <strong>
            {moment.utc(inprogressApplication?.createDate).format('MM/DD/YYYY')}
          </strong>
          .
          <br />
          <br />
          {modalDescription2}
        </div>
        <div slot="action-zone" className="inprogress-app-modal-btn-container">
          <MFBeaconButton
            role="button"
            variant="secondary"
            id="appInProgressEditBtn"
            data-name="appInProgressEditBtn"
            type="button"
            onClick={handleEditInProgressApplication}
            label="Edit In-Progress Application"
            noButtonMargin
          />
          <MFBeaconButton
            role="button"
            variant="primary"
            id="appInProgressContinueBtn"
            data-name="appInProgressContinueBtn"
            type="button"
            onClick={() =>
              pushToBrokerageDelegateUser(chosen, loadedData?.customerId)
            }
            label="Continue Anyway"
            noButtonMargin
          />
        </div>
      </MFBeaconModal>

      <style jsx>{styles}</style>
    </>
  );
};

export default ApplicationInProgressModal;
